<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.car') }}:
                |
                | {{ restricao.cod_imovel || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.situacao') }}:
                |
                | {{ getSituacao(restricao.status_imo) || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.bioma') }}:
                |
                | {{ restricao.biomas || '-' }}
                template(v-for='ano in anosProdes')
                    span(v-if="verificarAreaAno(restricao['sobrep_prodes_' + ano])")
                        br
                        b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaDesmatamentoAnoHa').replaceAll('{ano}', ano) }}:
                        |
                        | {{ formatNumber(restricao['sobrep_prodes_' + ano]) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaDesmatamentoTotalHa') }}:
                |
                | {{ formatNumber(restricao.soma_desmat) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao.areaHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ListaMmaProdesCar',

    data() {
        return {
            anosProdes: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]
        };
    },

    components: {
        Criticidade,
        BaseButton
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        getSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.ativo'
                    );
                case 'PE':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.pendente'
                    );
                case 'SU':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.suspenso'
                    );
                case 'CA':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.cancelado'
                    );
                
            }
        },
        verificarAreaAno(areaHaAno) {
            return areaHaAno && areaHaAno > 0;
        },
        formatNumber(number) {
            if (!number) return '-';

            if (Number.isInteger(number) || number % 1 === 0) {
                return parseInt(number);
            }
            
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    }
};
</script>
